var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.entry)?_c('div',{staticClass:"ms-4 me-4 mt-4 mb-4"},_vm._l((_vm.entry.children),function(e){return _c(_vm.getDetailComponent(e.type),{key:e.id,tag:"component",attrs:{"entry":e,"detailContext":_vm.detailContext}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }